import type { JobType, SpecialHandlingRequirement } from '../../../../reference-data/reference-data.api';
import { DropPointList } from './DropPointList';
import { LooseCargoDetailsForm } from './LooseCargoDetailsForm';
import type { JobDetail } from '../../../jobs.api';
import { useLooseCargo } from '../hooks/use-loose-cargo';

interface LooseCargoSectionProps {
  job: JobDetail | null;
  jobTypes: JobType[];
  specialHandlingRequirements: SpecialHandlingRequirement[];
  onChanged: () => Promise<void>;
}

function isLooseFamily(jobTypeCode: string, jobTypes: JobType[]): boolean {
  return jobTypes.find((t) => t.code === jobTypeCode)?.family === 'loose';
}

/**
 * Loose-cargo-specific job data (PRD → Job intake → Captured per job type (Loose cargo);
 * gitaumoses4/chukua#32) — owns its own visibility rule (an existing job, of the loose family),
 * so the page above just renders it unconditionally, same as ContainerDetailsSection.
 */
export function LooseCargoSection({ job, jobTypes, specialHandlingRequirements, onChanged }: LooseCargoSectionProps) {
  const { savingDropPoint, add, update, remove, reorder, detailsError, savingDetails, saveDetails } = useLooseCargo(job?.id ?? '', onChanged);
  if (!job || !isLooseFamily(job.jobTypeCode, jobTypes)) return null;

  return (
    <div className="mt-6 flex flex-col gap-8 border-t border-line pt-6">
      <DropPointList dropPoints={job.dropPoints} saving={savingDropPoint} onAdd={add} onUpdate={update} onRemove={remove} onReorder={reorder} />
      <LooseCargoDetailsForm
        details={job.looseCargoDetails}
        specialHandlingRequirements={specialHandlingRequirements}
        error={detailsError}
        saving={savingDetails}
        onSave={saveDetails}
      />
    </div>
  );
}
